import { axios } from 'services/axios';

const getPartner = async (partnerId) => {
    const res = await axios.get(`/partner/${partnerId}`, {
        headers: {
            'Cache-Control': 'no-cache',
            Pragma: 'no-cache',
            Expires: '0',
        },
    });

    return res.data;
};

export default getPartner;
